class UserPropertyModel {
  constructor({ key = null, value_type = null, value = null } = {}) {
    this.key = key;
    this.value_type = value_type;
    this.value = value;
    this.value_type_value = { [this.value_type]: value };
  }
  json() {
    return {
      key: this.key,
      value: this.value_type_value,
    };
  }
}

module.exports = UserPropertyModel;
